import { EnvironmentId } from "../app/core/enums/environment-id.enum";
import { Environment } from "../app/core/models/environment.model";

export const environment: Environment = {
  id: EnvironmentId.Development,
  apiBaseUrl: "https://taba-bff.dev.sibase-x.siemens.cloud/api",
  auth: {
    clientId: "804d41a2-4756-4ead-b647-beb82ab6a9f6",
    authority: "https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a/",
    scopes: "api://52a662a9-f8b5-44e3-8829-3cd130c107e0/Api.Access",
  },
};
